import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';


export interface ComplaintMessageUpsertState extends ApiState {
  complaintMessageId?: string
}

export default requestReducer<ComplaintMessageUpsertState>('COMPLAINT_MESSAGE_UPSERT')
